import Button from '@blaze-react/button';
import PropTypes from 'prop-types';
import { useState } from 'react';
import CaptainsClubForm from './CaptainsClubForm';
import SuperportLeadForm from './SuperportLeadForm';
import { PRODUCT_CAPTAINS_CLUB, PRODUCT_SUPERPORTS_LISTING } from './constants';

const SalesforceLead = ({ leadSource, buttonCaption, description, modalTitle }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        className="button button--center salesforce-lead__button"
        onClick={() => setModalOpen(true)}>
        {buttonCaption}
      </Button>

      {modalOpen && (
        <>
          {leadSource === PRODUCT_CAPTAINS_CLUB && (
            <CaptainsClubForm
              description={description}
              modalTitle={modalTitle}
              closeModal={() => setModalOpen(false)}
            />
          )}

          {leadSource === PRODUCT_SUPERPORTS_LISTING && (
            <SuperportLeadForm
              description={description}
              modalTitle={modalTitle}
              closeModal={() => setModalOpen(false)}
            />
          )}
        </>
      )}
    </>
  );
};

SalesforceLead.propTypes = {
  leadSource: PropTypes.string.isRequired,
  buttonCaption: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  modalTitle: PropTypes.string.isRequired
};

export default SalesforceLead;
